import { render, staticRenderFns } from "./NuevoTraspaso.vue?vue&type=template&id=41001ecd&scoped=true"
import script from "./NuevoTraspaso.vue?vue&type=script&lang=js"
export * from "./NuevoTraspaso.vue?vue&type=script&lang=js"
import style0 from "spinkit/spinkit.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./NuevoTraspaso.vue?vue&type=style&index=1&id=41001ecd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41001ecd",
  null
  
)

export default component.exports